module.exports = __webpack_public_path__ + "img/Group 1218.6932a0a7.svg";